export default __webpack_public_path__ + "static/media/ic_flash.e93c3fcb.svg";